<template>
	<div id="_filter">
		<div class="menuHandle">Filters<button class="closeButton" @click="closeFilter">x</button></div>
		<div class="menuBody">
			<table>
				<tr><td>Result Limits</td><td><input v-model="filterLimits" @change="updateFilter"></td></tr>
				<tr><td>Last days</td><td><input v-model="filterLastDays" @change="updateFilter"></td></tr>
				<tr><td>Location</td><td>
					<select v-model="filterLocations" @change="updateFilter">
						<option value="">ALL</option>
						<option value="PENDING">PENDING</option>
						<option value="HOU-2">HOU-2</option>
						<option value="ISILON">ISILON</option>
					</select>
				</td></tr>
				<tr><td>Category</td><td>
					<select v-model="filterCategory" @change="updateFilter">
						<option v-for="category in categories" v-bind:value="category">{{category.toUpperCase()}}</option>
					</select>	
				</td></tr>
				<tr><td>Tags</td><td><input v-model="filterTags" @change="updateFilter"></td></tr>
				<tr><td>Width</td><td><input v-model="filterWidth" @change="updateFilter"></td></tr>
				<tr><td>Height</td><td><input v-model="filterHeight" @change="updateFilter"></td></tr>
			</table>
		</div>
	</div>
</template>

<script>

export default {
  name: 'filter',
  data () {
    return {
		filterLimits: 10,
		filterLastDays: 14,
		filterLocations: '',
		filterCategory: '',
		filterTags: '',
		filterWidth: '',
		filterHeight: '',
		searchFilters: {},
		categories: ["","ads","shows","music","news","pscd","infomercial","movie","hai kich"]
    }
  },
  methods: {
	closeFilter: function(){
		this.$emit('toggleFilter',true)
	},
	updateFilter: function (){
		this.searchFilters = {
			filterLimits: this.filterLimits,
			filterLastDays: this.filterLastDays,
			filterLocation: this.filterLocations,
			filterCategory: this.filterCategory,
			filterTags: this.filterTags,
			filterWidth: this.filterWidth,
			filterHeight: this.filterHeight
		}
		this.$emit('filterUpdate',this.searchFilters)
	}
  },
  created: function (){
	this.updateFilter()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#_filter{
	position:absolute;
	top:50%;
	left:50%;
	right:0px;
	bottom:0px;
	width:300px;
	height:200px;
	background-color:#3e4c63;
	z-index:100;
	border-radius:5px;
}

.menuBody{
	text-align:left;
	background-color:#a7adb7;
	height:100%;
	border-radius:5px;
}
.closeButton{
	float:right;
	margin:2px;
	padding:2px;
	height:20px;
	border-radius:2px;
}
	
</style>



// WEBPACK FOOTER //
// src/components/filter.vue